import {defineMessages} from 'react-intl';

export default defineMessages({
	color: {
		id: 'description.color',
		defaultMessage: 'Color: {color}',
	}
});
